import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { connect, useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from '../../../components/hoc/Ax';
import tapIcon from '../../../services/TapIcon';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';
import axios from 'axios';
import api from '../../../services/api';

const WarehouseIndentAddDocument = forwardRef((props, ref) => {
    const { indentData, getIndentDetail } = props;
    useImperativeHandle(ref, () => ({
        showModalInit() {
            showModalInit()
        }
    }));
    const access_token = useSelector(state => state.auth.access_token ? state.auth.access_token : "")
    const [loadForm, setLoadForm] = useState(false);
    const [documentSubmitting, setDocumentSubmitting] = useState(false);
    const [other, setOther] = useState('N');
    const [addDocumentForm, setAddDocumentForm] = useState({
        name: "",
        photo: null,
        number :""
    });
    const [documentTypes, setDocumentTypes] = useState([]);
    const [indentDetail, setIndentDetail] = useState(null);
    const modalId = useRef(uuid());
    const addDocModal = useRef(null);

    const iscDocTypeUrl = `${ORG_API_BASE_URL_2}/setting/isc_doc_types`;
    const indentDocUrl = `${INVENTORY_API_BASE_URL_2}/warehouse_indent`;

    useEffect(() => {
        addDocModal.current = new Modal(document.getElementById(modalId.current), { keyboard: false, backdrop: false });
    }, []);

    const showModalInit = () => {
        addDocModal.current.show();
        setLoadForm(true);
        setDocumentSubmitting(false);
        setIndentDetail({ ...indentData });
        setAddDocumentForm({
            name: "",
            number :"",
            photo: null,
        });

        HttpAPICall.withAthorization('GET', iscDocTypeUrl, access_token, {}, {}, (response) => {
            setDocumentTypes(response.data.map(s => ({ value: s, label: s })));
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => setLoadForm(false));
    };

    const handleFileChange = async (e) => {
        let file = e.target.files[0];
        setAddDocumentForm(prevForm => ({ ...prevForm, photo: file }));
    };
    const addIndentDocument = (e) => {
        e.preventDefault();
        setDocumentSubmitting(true);
        const formData = new FormData();
        formData.append('name', addDocumentForm.name);
        formData.append('number', addDocumentForm.number);
        formData.append('photo', addDocumentForm.photo);
        formData.append('transaction_id', indentDetail?.transaction_id);
        let headers = { 'Authorization': 'Bearer ' + access_token, };
        api.server2Api.post(`${indentDocUrl}/document_add`, formData, {headers: headers})
            .then(response => {
                toast.success(response.data.msg);
                getIndentDetail(indentDetail?.transaction_id);
                addDocModal.current.hide();
            })
            .catch(error => toast.error(error?.response?.data?.msg || 'Error'))
            .finally(() => setDocumentSubmitting(false));
    };

    return (
        <div className="modal fade" id={modalId.current} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addDocModalLabel">Add Document</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    {loadForm
                        ? <Loader />
                        : <Ax>
                            <form onSubmit={addIndentDocument}>
                                <div className="modal-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-3">
                                            <label className="form-label require">Document Type</label>
                                        </div>
                                        <div className="col-sm-7">
                                            {other === "Y"
                                                ? <input
                                                    name="name"
                                                    type="text"
                                                    value={addDocumentForm.name}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => setAddDocumentForm({ ...addDocumentForm, name: e.target.value })}
                                                    placeholder="Please enter Type Name"
                                                    required={true}
                                                />
                                                : <TapSelect
                                                    options={documentTypes}
                                                    changeEvent={(selectedOption) => setAddDocumentForm({ ...addDocumentForm, name: selectedOption ? selectedOption.value : '' })}
                                                    value={documentTypes.find(u => addDocumentForm.name === u.value)}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    placeholder="Select Document Type"
                                                    autoComplete="off"
                                                    required={true}
                                                    autoFocus={true}
                                                />
                                            }
                                        </div>
                                        <div className="col-sm-2">
                                            <input
                                                name="other"
                                                type="checkbox"
                                                value={other}
                                                onChange={() => {
                                                    setOther(other === 'N' ? 'Y' : 'N');
                                                    setAddDocumentForm(pre => ({...pre, name: '' }))
                                                }}
                                                checked={other === 'Y'}
                                                className="form-check-input"
                                                id="other"
                                            />
                                            <label className="form-check-label mx-2" htmlFor="other">New</label>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Document Number</label>
                                        </div>
                                        <div className="col-md-7">
                                            <input
                                                name="number"
                                                type="text"
                                                value={addDocumentForm.number}
                                                onChange={(e) => setAddDocumentForm({ ...addDocumentForm, number: e.target.value })}
                                                className="form-control"
                                                autoComplete="off"
                                                placeholder="Enter Document Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <label className="form-label require">Document</label>
                                        </div>
                                        <div className="col-md-7">
                                            <input
                                                name="photo"
                                                type="file"
                                                onChange={(e) => {
                                                    handleFileChange(e);
                                                }}
                                                className="form-control"
                                                autoComplete="off"
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" disabled={documentSubmitting} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={documentSubmitting} className="btn btn-primary">Submit {documentSubmitting && <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />}</button>
                                </div>
                            </form>
                        </Ax>
                    }
                </div>
            </div>
        </div>
    );
});

export default WarehouseIndentAddDocument;
